import type { Feature } from '@luna/gatekeeper';

export const changeCardDesign: Feature = {
    enabled: true,
    _description: 'Displays card design change card in the card services list',
};
